import { Client } from '@opanuj/shared/types';

export type ClientSortKey = 'createdAt' | 'name' | 'email' | 'phone';

export const formatPhoneNumber = (value?: string) => {
	if (!value) return 'Brak danych';
	const digits = value.replace(/\D/g, '');
	if (!digits) return 'Brak danych';
	if (digits.length <= 3) return digits;
	if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
	if (digits.length <= 9) return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
	return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)} ${digits.slice(9)}`;
};

export const getClientEmailList = (client: Partial<Client> | any) => {
	const emails = client?.notifications?.emails?.length ? client.notifications.emails : [client?.email];
	return (emails || []).filter(Boolean);
};

export const getClientProductsCount = (client: Partial<Client> | any) => {
	if (!client?.products || typeof client.products !== 'object') return 0;
	return Object.keys(client.products).length;
};

export const getClientLessonsPoolCount = (client: Partial<Client> | any) => {
	return Array.isArray(client?.lessonsPool) ? client.lessonsPool.length : 0;
};

export const isClientActive = (client: Partial<Client> | any, openedReservations: number = 0) => {
	return getClientProductsCount(client) > 0 || Number(openedReservations) > 0;
};

export const matchesClientQuery = (client: Partial<Client> | any, query: string) => {
	const normalizedQuery = query.trim().toLowerCase();
	if (!normalizedQuery) return true;

	return (
		(client?.name || '').toLowerCase().includes(normalizedQuery) ||
		(client?.email || '').toLowerCase().includes(normalizedQuery)
	);
};

export const getActiveOnlyFromSearch = (search: string) => {
	const params = new URLSearchParams(search);
	return params.get('active') === '1' || params.get('active') === 'true';
};

export const getSortByFromSearch = (search: string, allowedKeys: readonly string[], fallback: string = 'name') => {
	const params = new URLSearchParams(search);
	const sortValue = params.get('sortBy');
	return allowedKeys.includes(sortValue || '') ? sortValue! : fallback;
};

export const getSortDirectionFromSearch = (search: string, fallback: 'asc' | 'desc' = 'asc') => {
	const params = new URLSearchParams(search);
	const directionValue = params.get('sortDir');
	return directionValue === 'desc' ? 'desc' : fallback;
};

export const sortClients = (clients: any[], sortBy: string, sortDirection: 'asc' | 'desc') => {
	const sorted = [...clients].sort((a: any, b: any) => {
		const aValue = sortBy === 'products'
			? getClientProductsCount(a)
			: sortBy === 'lessonsPool' ? getClientLessonsPoolCount(a) : a?.[sortBy];
		const bValue = sortBy === 'products'
			? getClientProductsCount(b)
			: sortBy === 'lessonsPool' ? getClientLessonsPoolCount(b) : b?.[sortBy];

		if (aValue == null && bValue == null) return 0;
		if (aValue == null) return -1;
		if (bValue == null) return 1;

		if (typeof aValue === 'number' && typeof bValue === 'number') {
			return aValue - bValue;
		}

		return String(aValue).localeCompare(String(bValue), undefined, { sensitivity: 'base' });
	});

	return sortDirection === 'asc' ? sorted : sorted.reverse();
};
